/**
 * Offer validity helper for the Festive Stencil & Cone Promotion
 * Valid period: October 6 to November 6
 */
export const isSpecialOfferActive = () => {
  const now = new Date();
  const year = now.getFullYear();

  // Start date: October 6 00:00:00 (allowing Oct 5 for setup/preview)
  const startDate = new Date(year, 9, 5, 0, 0, 0);

  // End date: November 6 23:59:59
  const endDate = new Date(year, 10, 6, 23, 59, 59);

  return now >= startDate && now <= endDate;
};

export const OFFER_VALIDITY_TEXT = "Oct 6 – Nov 6 Only";
